export default "__VITE_ASSET__TJzKn87W__"